import { render, staticRenderFns } from "./Typemark.vue?vue&type=template&id=2b2f1295&"
import script from "./Typemark.vue?vue&type=script&lang=js&"
export * from "./Typemark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports